import { useEffect } from 'react';

export const SITE_URL = 'https://ssipl.lk';
const DEFAULT_IMAGE = `${SITE_URL}/og-image.png`;

const setMeta = (attr, key, content) => {
  if (!content) return;
  let el = document.head.querySelector(`meta[${attr}="${key}"]`);
  if (!el) {
    el = document.createElement('meta');
    el.setAttribute(attr, key);
    document.head.appendChild(el);
  }
  el.setAttribute('content', content);
};

const setCanonical = (href) => {
  let el = document.head.querySelector('link[rel="canonical"]');
  if (!el) {
    el = document.createElement('link');
    el.setAttribute('rel', 'canonical');
    document.head.appendChild(el);
  }
  el.setAttribute('href', href);
};

/**
 * Keeps title, description, canonical and social tags in sync per route.
 * Crawlers that execute JS (Google) read the updated tags; the static tags in
 * index.html remain the fallback for scrapers that do not.
 */
const Seo = ({
  title,
  description,
  path = '/',
  image = DEFAULT_IMAGE,
  robots = 'index, follow, max-image-preview:large, max-snippet:-1',
  jsonLd = null
}) => {
  useEffect(() => {
    const url = `${SITE_URL}${path}`;

    document.title = title;
    setMeta('name', 'description', description);
    setMeta('name', 'robots', robots);
    setCanonical(url);

    setMeta('property', 'og:title', title);
    setMeta('property', 'og:description', description);
    setMeta('property', 'og:url', url);
    setMeta('property', 'og:image', image);

    setMeta('name', 'twitter:title', title);
    setMeta('name', 'twitter:description', description);
    setMeta('name', 'twitter:image', image);
  }, [title, description, path, image, robots]);

  useEffect(() => {
    if (!jsonLd) return undefined;
    const el = document.createElement('script');
    el.type = 'application/ld+json';
    el.text = JSON.stringify(jsonLd);
    document.head.appendChild(el);
    return () => {
      document.head.removeChild(el);
    };
  }, [jsonLd]);

  return null;
};

export default Seo;
